import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { ACTION_FIELDS, RESULTS } from "../../../../ducks/indicatorManagament";
import QuestionStructureSelect from "./QuestionStructureSelect";
import { LANGUAGE } from "../../../../ducks/languageSelector";
import { INDICATOR_MANAGEMENT_STORE, LANGUAGE_SELECTOR } from "../../../../common/constant";

const mapStateToProps = (state, ownProps) => {
  return {
    actionFields: state[INDICATOR_MANAGEMENT_STORE][ACTION_FIELDS],
    results: state[INDICATOR_MANAGEMENT_STORE][RESULTS],
    changeProperty: ownProps.changeProperty,
    selectedActionFieldId: ownProps.selectedActionFieldId,
    selectedResultId: ownProps.selectedResultId,
    onActionFieldChange: ownProps.onActionFieldChange,
    onResultChange: ownProps.onResultChange,
    locale: state[LANGUAGE_SELECTOR][LANGUAGE]
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionStructureSelect);
